import { AnalyticIdentifier } from '@common/neo.tax';
import { useEffect, useState } from 'react';

import { env, useAnalyticId, useScript, isReCaptchaDisabled } from '@neo.tax/shared';

export const useReCaptcha = ({
  onChecked,
  visible,
}: {
  visible: boolean;
  onChecked: (token: string) => void;
}): {
  reCaptchaId: string;
  loading: boolean;
} => {
  const [widgetId, setWidgetId] = useState<string | null>(null);
  const reCaptchaId = useAnalyticId(AnalyticIdentifier.RECAPTCHA_CHECKBOX);

  const status = useScript({
    src: '//www.google.com/recaptcha/enterprise.js?render=explicit',
    loadedName: 'ReCaptcha',
  });

  useEffect(() => {
    if (!visible || widgetId !== null || status !== 'ready' || isReCaptchaDisabled()) {
      return;
    }
    const id = window.grecaptcha?.enterprise.render(reCaptchaId, {
      sitekey: env.REACT_APP_FIREBASE_RECAPTCHA_KEY,
      callback: onChecked,
    });
    setWidgetId(id ?? null);
  }, [onChecked, reCaptchaId, visible, widgetId, status]);

  useEffect(() => {
    if (visible) {
      return;
    }
    setWidgetId(null);
  }, [visible]);

  return { reCaptchaId, loading: visible && widgetId === null };
};
